import React from "react";

import styles from "./AccountDetails.module.scss";

export const AccountDetailsContainer: React.FC<
  React.HTMLAttributes<HTMLDivElement>
> = ({ children, className, ...rest }) => (
  <div
    className={`${styles.accountDetailsContainer} ${className ?? ""}`}
    {...rest}>
    {children}
  </div>
);

export const AccountDetailsGrid: React.FC<
  React.HTMLAttributes<HTMLDivElement>
> = ({ children, className, ...rest }) => (
  <div
    className={`${styles.accountDetailsGrid} ${className ?? ""}`}
    {...rest}>
    {children}
  </div>
);

export const CredentialsSection: React.FC<
  React.HTMLAttributes<HTMLDivElement>
> = ({ children, className, ...rest }) => (
  <div className={`${styles.credentialsSection} ${className ?? ""}`} {...rest}>
    {children}
  </div>
);

export const RightColumnSection: React.FC<
  React.HTMLAttributes<HTMLDivElement>
> = ({ children, className, ...rest }) => (
  <div className={`${styles.rightColumnSection} ${className ?? ""}`} {...rest}>
    {children}
  </div>
);

export const SectionDivider: React.FC<
  React.HTMLAttributes<HTMLDivElement>
> = ({ className, ...rest }) => (
  <div className={`${styles.sectionDivider} ${className ?? ""}`} {...rest} />
);

export const CompactUserSettingsContainer: React.FC<
  React.HTMLAttributes<HTMLDivElement>
> = ({ children, className, ...rest }) => (
  <div
    className={`${styles.userSettingsContainer} ${styles.compactUserSettings} ${className ?? ""}`}
    {...rest}>
    {children}
  </div>
);

export const UserSettingsContainer: React.FC<
  React.FormHTMLAttributes<HTMLFormElement>
> = ({ children, className, ...rest }) => (
  <form
    className={`${styles.userSettingsContainer} ${className ?? ""}`}
    {...rest}>
    {children}
  </form>
);

export const FirstUserSettingsContainer: React.FC<
  React.FormHTMLAttributes<HTMLFormElement>
> = ({ children, className, ...rest }) => (
  <form
    className={`${styles.userSettingsContainer} ${styles.firstUserSettingsContainer} ${className ?? ""}`}
    {...rest}>
    {children}
  </form>
);

export const FlexRow: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  children,
  className,
  ...rest
}) => (
  <div className={`${styles.flexRow} ${className ?? ""}`} {...rest}>
    {children}
  </div>
);

export const UserName: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  children,
  className,
  ...rest
}) => (
  <div className={`${styles.userName} ${className ?? ""}`} {...rest}>
    {children}
  </div>
);

export const FieldsSection: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  children,
  className,
  ...rest
}) => (
  <div className={`${styles.fieldsSection} ${className ?? ""}`} {...rest}>
    {children}
  </div>
);

export const ButtonWrapper: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  children,
  className,
  ...rest
}) => (
  <div className={`${styles.buttonWrapper} ${className ?? ""}`} {...rest}>
    {children}
  </div>
);

export const AccountTitleWrapper: React.FC<
  React.HTMLAttributes<HTMLDivElement>
> = ({ children, className, ...rest }) => (
  <div className={`${styles.accountTitleWrapper} ${className ?? ""}`} {...rest}>
    {children}
  </div>
);
